import { privateAxios } from '@/common/api/axios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UsePriceSurveysProps<T> = {
  filters?: {
    cityId?: string
    status?: string
    productId?: string
    surveyConductedAtGt?: string
    surveyConductedAtLt?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const usePriceSurveys = <T,>({
  filters: { cityId, status, productId, surveyConductedAtGt, surveyConductedAtLt, page } = {},
  mapper = Mapper.default<T>(),
}: UsePriceSurveysProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['priceSurveys', cityId, status, productId, surveyConductedAtGt, surveyConductedAtLt, page],
    queryFn: () => {
      return privateAxios.get('/price_surveys', {
        params: {
          'q[city_id_eq]': cityId,
          'q[status_eq]': status,
          'q[product_id_eq]': productId,
          'q[survey_conducted_at_gteq]': surveyConductedAtGt,
          'q[survey_conducted_at_lteq]': surveyConductedAtLt,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
